import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, Text } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { memo } from 'react';
import { getChartElementColor } from 'analytics/components/panels/utils/theming/theming';
import styles from './chartInstrumentLegend.module.scss';
export const ChartInstrumentLegend = memo(function ChartInstrumentLegend({ instrument, legend, visualization, onToggleLegendItem, onMouseEnterLegendItem, onMouseLeaveLegendItem, hoveredLegend, }) {
    var _a;
    const { series, options } = instrument.data;
    const { layout } = (_a = options === null || options === void 0 ? void 0 : options.legend) !== null && _a !== void 0 ? _a : {
        layout: 'horizontal',
    };
    const isHorizontal = layout === 'horizontal';
    return (_jsx(FlexBox, Object.assign({ padding: isHorizontal ? '0' : '0 0 0 400', flexDirection: isHorizontal ? 'row' : 'column', gap: isHorizontal ? '400' : '200', justifyContent: "center" }, { children: series.map(({ label, options }, index) => {
            const color = getChartElementColor(index, undefined, options === null || options === void 0 ? void 0 : options.color);
            const legendItemClass = classnames(styles.legendItem, {
                [styles.legendItemInactive]: hoveredLegend && hoveredLegend !== label,
            });
            const legendIconClass = classnames(styles.legendIcon, {
                [styles.legendIconBar]: visualization === 'bar',
                [styles.legendIconLine]: visualization === 'line',
            });
            return (_jsxs(FlexBox, Object.assign({ gap: "200", flexDirection: "row", alignItems: "center", className: legendItemClass, onClick: () => onToggleLegendItem(label), onMouseEnter: () => onMouseEnterLegendItem === null || onMouseEnterLegendItem === void 0 ? void 0 : onMouseEnterLegendItem(label), onMouseLeave: () => onMouseLeaveLegendItem === null || onMouseLeaveLegendItem === void 0 ? void 0 : onMouseLeaveLegendItem(label) }, { children: [_jsx("span", { className: legendIconClass, style: {
                            borderColor: color,
                            backgroundColor: legend.includes(label) ? color : 'transparent',
                        } }), _jsx(Text.Paragraph, Object.assign({ variant: "4", subdued: true }, { children: label }))] }), label));
        }) })));
});
